import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import confetti from 'canvas-confetti';

gsap.registerPlugin(ScrollTrigger);

const initPricing = () => {

  document.querySelectorAll('[data-pricing-group]').forEach((pricingGroup) => {
    const pricingList = pricingGroup.querySelector('.pricing-item_list');
    const pricingItems = pricingGroup.querySelectorAll('.pricing-item');
    const finalItem = pricingGroup.querySelector('.final-item');

    let pricingCanvas = document.createElement('canvas');
    pricingCanvas.classList.add('final-item_confetti');
    finalItem.appendChild(pricingCanvas);

    let pricingConfetti = confetti.create(pricingCanvas, {
      resize: true,
      useWorker: true
    });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: pricingList,
        start: 'top 60%',
        end: 'bottom 60%',
        scrub: true,
        invalidateOnRefresh: true,
        onLeave: () => {
          finalItem.classList.add('final-item--active');

          // left
          pricingConfetti({
            particleCount: 50,
            angle: 135,
            origin: { y: 0.6, x: 0.4 },
            colors: ['#fc372d'],
          });

          // right
          pricingConfetti({
            particleCount: 50,
            angle: 45,
            origin: { y: 0.6, x: 0.6 },
            colors: ['#fc372d'],
          });
        },
        onEnterBack: () => {
          finalItem.classList.remove('final-item--active');
        }
      }
    });

    // reset confetti
    ScrollTrigger.create({
      trigger: pricingGroup.parentNode,
      start: 'top bottom',
      end: 'bottom top',
      onLeaveBack: () => {
        pricingConfetti.reset();
      },
      onLeave: () => {
        pricingConfetti.reset();
      }
    });

    pricingItems.forEach((pricingItem, index) => {
      let amount = pricingItem.querySelector('.pricing-item_amount');
      let amountBG = pricingItem.querySelector('.pricing-item_amount-bg');
      let divider = pricingItem.querySelector('.pricing-item_divider');
      let dividerBG = pricingItem.querySelector('.pricing-item_divider-bg');
      let dividerDuration = 1 * (divider.offsetHeight / amount.offsetHeight);

      if(index === 0) {
        pricingItem.classList.add('pricing-item--active');
        gsap.set(amountBG, { height: '100%' });

        tl.to({}, { duration: 1, ease: 'none' });
      } else {
        tl.call(() => {
          pricingItem.classList.toggle('pricing-item--active');
        })
        .to(amountBG, {
          height: '100%',
          duration: 1,
          ease: 'none'
        });
      }

      if(index < pricingItems.length) {
        tl.to(dividerBG, {
          height: '100%',
          duration: dividerDuration,
          ease: 'none'
        })
      }
    });
  });

};

export { initPricing };